<template>
  <div>
    <div
      :class="{
        storeHeader: true,
        isHome: true,
        header_container: isActive,
        header_containers: hasError
      }"
    >
      <div class="header_inner">
        <div class="logo" v-if="marketInfo && marketInfo.domain">
          <!-- <a
            v-if="marketInfo && marketInfo.logo"
            :href="`/markets/${marketInfo.domain}`"
          >
            <img :src="marketInfo.logo" :alt="marketInfo.name" />
          </a>
          <a
            v-else
            :href="`/markets/${marketInfo.domain}`"
            class="navbar-brand"
          >
            <img src="../../assets/images/logos.png" />
          </a>
          <div class="decollator"></div> -->
          <div class="storeName">
            <a :href="`/`">
              <!-- {{ marketInfo.name }} -->
              AI智能体市场
            </a>
          </div>
        </div>
        <div class="logo" v-else>
          <a href="/" class="navbar-brand storeName">
            <!-- <img src="../../assets/images/logos.png" /> -->
            AI智能体市场
          </a>
        </div>
        <a
          href="https://hub.grapps.cn/docs/onLine/aindex"
          target="_blank"
          style="
            color: #fff;
            cursor: pointer;
            font-size: 16px;
            margin-top: 4px;
            margin-left: 80px;
          "
        >
          发布应用
        </a>
        <a
          href="https://hub.grapps.cn/docs/"
          target="_blank"
          style="
            font-size: 16px;
            color: #fff;
            cursor: pointer;
            margin-top: 4px;
            margin-left: 16px;
          "
        >
          使用指南
        </a>
        <!-- 搜索应用 -->
        <div v-if="!marketClosed && home" class="header_search">
          <el-input
            v-model="searchQuery"
            placeholder="请输入关键词搜索应用"
            class="search_input"
            @keyup.enter.native="handleSearchApp"
          ></el-input>
          <el-button class="search_btn" @click="handleSearchApp" slot="append">
            <svg-icon
              icon-class="search"
              style="font-size: 18px; vertical-align: middle"
            ></svg-icon>
          </el-button>
        </div>
        <div class="header-r">
          <div
            v-if="userInfo && userInfo.userID && enterpriseInfo"
            class="menu-r user_info"
          >
            <router-link
              :to="isAdmin ? { name: 'overview' } : { name: 'myOverview' }"
              class="console"
            >
              控制台
            </router-link>

            <el-popover
              :offset="40"
              placement="bottom-end"
              width="300"
              trigger="hover"
              :class="{ 'home-avatar': home }"
            >
              <div slot="reference">
                <el-avatar
                  size="small"
                  v-if="userInfo.picUrl"
                  :src="userInfo.picUrl"
                  :class="{ 'home-avatar': home }"
                ></el-avatar>
                <el-avatar
                  size="small"
                  v-else
                  style="background: #fff; color: #0067b8"
                >
                  {{ userInfo.realName.substr(0, 1) }}
                </el-avatar>
              </div>
              <div class="enInfoBox">
                <router-link
                  :to="isAdmin ? { name: 'overview' } : { name: 'myOverview' }"
                >
                  {{ enterpriseInfo && enterpriseInfo.name }}(控制台)
                </router-link>
              </div>
              <div class="feature">
                <el-tag
                  style="margin-right: 8px"
                  v-for="item in userInfo.roles"
                  :key="item"
                  type="info"
                  effect="plain"
                  >{{ item }}</el-tag
                >
              </div>
              <div class="u-footer">
                <a @click="showChangePassword" style="border-left: 0">
                  修改密码
                </a>
                <a @click="enterLogin">退出登录</a>
              </div>
            </el-popover>
          </div>
          <div
            v-else
            :class="{ login_links: true }"
            :id="home ? 'home_login_links' : ''"
          >
            <a @click="handleLogins(true)" style="border: none" class="disembark">登录</a>
          </div>
        </div>
      </div>
    </div>
    <change-password
      :dialogVisible="changePasswordShow"
      :onSuccess="hideChangePassword"
      :onClose="hideChangePassword"
    ></change-password>
  </div>
</template>

<script>
import logoImg from '@/assets/images/logo.png';
import logoTitImg from '@/assets/images/logo2.png';
import Vue from 'vue';
import ChangePassword from './components/changePassword';
import { validateEmpty, validateRedirect } from '@/utils/validate';

const header = Vue.extend({
  name: 'Header',
  props: [
    'tabs',
    'marketInfo',
    'defaultMarket',
    'showDoc',
    'marketClosed',
    'isActive',
    'hasError',
    'home',
    'detail',
    'isDetailPage',
    'type'
  ],
  data() {
    return {
      visible: true,
      scroll: false,
      logoImg,
      logoTitImg,
      switchClass: true,
      isLogout: true,
      changePasswordShow: false,
      searchQuery: '', // 应用搜索查询参数
      isSiteRegister:
        this.$store.state.user.platformInfo.siteRegister == 'true',
      isAdmin:
        window.sessionStorage.getItem('isAdmin') != 'false'
    };
  },
  components: {
    'change-password': ChangePassword
  },
  computed: {
    defaultMarketDomain() {
      return this.$store.state.user.platformInfo.defaultMarketDomain;
    },
    enterpriseInfo() {
      return this.$store.state.enterprise.enterpriseInfo;
    },
    userInfo() {
      return this.$store.state.user.userInfo;
    },
    scrollClass() {
      if (this.scroll) {
        return 'storeHeader ' + 'scroll';
      } else {
        return 'storeHeader';
      }
    }
  },
  watch: {
    type(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.searchQuery = newVal;
      }
    }
  },
  created() {
    this.getUserInfo();
  },
  mounted() {
    // 给window添加一个滚动滚动监听事件
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    // 离开该页面需要移除这个监听的事件
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    // 搜索应用键盘按下搜索应用
    handleSearchApp() {
      // 如果是详情页,就跳转列表页
      if (this.isDetailPage) {
        this.$router.push({
          name: 'appstore',
          params: { searchQuery: this.searchQuery }
        });
      } else {
        this.$emit('handleSearchApp', this.searchQuery);
      }
      this.searchQuery = ''
    },
    handleScroll() {
      // 改变元素#searchBar的top值
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 0) {
        this.scroll = true;
      } else {
        this.scroll = false;
      }
    },
    hideChangePassword() {
      this.changePasswordShow = false;
    },
    showChangePassword() {
      this.changePasswordShow = true;
    },
    getUserInfo() {
      if (!this.userInfo || !this.userInfo.userID) {
        this.$store
          .dispatch('GetUserInfo')
          .then((res) => {
            if (res && res.eid) {
              window.sessionStorage.setItem('creatorID', res.userID);
              if (res.roles.indexOf('企业管理员') != -1 || res.roles.indexOf('应用管理员') != -1) {
                window.sessionStorage.setItem('isAdmin', true);
              } else {
                if (res.roles.indexOf('普通用户') != -1) {
                  window.sessionStorage.setItem('isAdmin', false);
                } else if (res.roles.indexOf('分享用户角色') != -1) {
                  window.sessionStorage.setItem('isAdmin', false);
                } else {
                  window.sessionStorage.setItem('isAdmin', true);
                }
              }
              this.isAdmin =
                window.sessionStorage.getItem('isAdmin') != 'false';
              this.$store.dispatch('GetEnterpriseInfo', res.eid).catch(() => {
                this.logout();
              });
            }
          })
          .catch((re) => {
            // ignore
          });
      }
    },
    getRedirect() {
      var redirect = this.$route.fullPath;
      if (this.$route.query.redirect) {
        redirect = this.$route.query.redirect;
      }
      if (redirect == '/enterprise/login') {
        return '/manage/overview/';
      }
      return redirect;
    },
    enterLogin() {
      this.$confirm('退出登录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.FedLogOut();
          window.sessionStorage.removeItem('path');
        })
        .catch(() => {});
    },
    FedLogOut() {
      this.$store.dispatch('FedLogOut').then(() => {
        this.handleLogins(false);
      });
    },
    handleLogins(bool = true) {
      if (bool) {
        const path = window.location.href;
        if (
          !window.sessionStorage.getItem('path') &&
          path.indexOf('enterprise/login') == -1 &&
          path.indexOf('enterprise/register') == -1
        ) {
          window.sessionStorage.setItem('path', path);
        }
      }
      this.$router.push({
        name: 'login'
      });
    },
    handleRegister(bool) {
      if (bool) {
        const path = window.location.href;
        if (
          !window.sessionStorage.getItem('path') &&
          path.indexOf('enterprise/login') == -1 &&
          path.indexOf('enterprise/register') == -1
        ) {
          window.sessionStorage.setItem('path', path);
        }
      }
      this.$router.push({
        name: 'register'
      });
    },
    releaseApp() {
      window.location = validateRedirect(
        'https://www.rainbond.com/docs/store/onLine/aindex'
      );
    }
  }
});

export default header;
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/styles/mixin.scss';
@import 'src/styles/header.scss';

.showModal {
  display: none;
}
.enInfoBox,
.feature {
  transform: translate(0px, -10px);
  width: 100%;
  padding: 16px;
  border-bottom: 1px solid rgb(239, 239, 239);
}
.u-footer {
  display: flex;
  a {
    flex: 1 1 0%;
    text-align: center;
    border-left: 1px solid rgb(222, 222, 222);
  }
}
.administrator {
  float: right;
  line-height: 50px;
}
.administrator {
  color: #ffffff !important;
}
.administrator:hover {
  color: #ffffff !important;
}
.header_left {
  display: flex;
  .logo {
    height: 240px;
    margin-right: 26px;
  }
  .header_link {
    line-height: 40px;
  }
  a {
    color: #fff;
  }
}
// 动态控制
.el-popover__reference {
  display: flex;
}

::v-deep .el-avatar {
  width: 40px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
}
.home-avatar .el-avatar {
  background-color: #448ef7;
}
.isHome {
  background-color: #0067b8 !important;
  // border-bottom: 1px solid #cccccc;
  box-shadow: none !important;
  z-index: 999;
}
#home_login_links {
  a {
    color: #fff !important;
  }
  // a:first-child {
  //   border-right: 1px solid #161718 !important;
  // }
}
.decollator {
  width: 2px;
  height: 31px;
  background-color: #fff;
  margin: 0px 12px;
}
.storeName {
  a {
    color: #fff;
  }
  font-size: 24px;
  height: 40px;
  line-height: 40px;
  font-weight: 600;
  margin-top: 4px;
  font-family: PingFangSC,helvetica neue,hiragino sans gb,arial,microsoft yahei ui,microsoft yahei,simsun,sans-serif!important;
}
.disembark{
  color: #fff !important;
  font-size: 18px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Header/store.vue